import React from "react";
import { Card, Heading4, theme } from "@ovotech/element";
import styled from "styled-components";
import { TariffInformationLabel } from "../../models/TariffInformationLabel";
import FuelTable from "../FuelTable/FuelTable";

interface TariffCardProps {
  name: string;
  activeFrom: string;
  tils: TariffInformationLabel[];
}

const StyledCard = styled(Card)`
  padding: 0;
  margin-bottom: ${theme.space["5"]};
  margin-top: ${theme.space["5"]};
`;

const CardHeader = styled("header")`
  padding-top: ${theme.space["6"]};
  padding-left: ${theme.space["3"]};
  padding-bottom: ${theme.space["3"]};
`;

function TariffCard({ name, activeFrom, tils }: TariffCardProps) {
  return (
    <StyledCard>
      <CardHeader>
        <Heading4>
          {name} -{" "}
          {new Intl.DateTimeFormat("en-GB").format(new Date(activeFrom))}
        </Heading4>
      </CardHeader>
      {tils.map((til) => (
        <FuelTable til={til} key={til.oepTariffId} />
      ))}
    </StyledCard>
  );
}

export default TariffCard;
